import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Obrigado from "../pages/obrigado/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/obrigado",
    element: <Obrigado />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;